var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "table-toolbar",
        {
          attrs: {
            "": _vm.isViewsSettingsHidden,
            "filters-count": _vm.filtersCount,
            "grid-data-loading": _vm.loadingStateValue,
            headers: _vm.headers,
            "prepared-headers": _vm.preparedHeaders,
            "views-list": _vm.viewsList,
            "active-view-key": _vm.activeViewKey,
            "views-loading": _vm.viewsLoading,
          },
          on: {
            "reset-filters": _vm.resetFilters,
            refresh: _vm.refresh,
            "change-active-view": function ($event) {
              return _vm.$emit("active-view-changed", $event)
            },
            "save-edit-view": function ($event) {
              return _vm.$emit("view-changed", $event)
            },
            "remove-view": function ($event) {
              return _vm.$emit("remove-view", $event)
            },
          },
        },
        [[_vm._t("toolbar")]],
        2
      ),
      _vm._t("default", null, {
        tableProps: _vm.tableProps,
        tableListeners: _vm.tableListeners,
        filtersProps: _vm.filtersProps,
        filtersListeners: _vm.filtersListeners,
      }),
      _vm.dataSourceAdapterOptions
        ? _c(
            _vm.dataSourceAdapterOptions.component,
            _vm._b(
              {
                ref: "remoteDataSource",
                tag: "component",
                attrs: { initialSortBy: _vm.initialSortBy },
                on: { "data-loaded": _vm.onRemoteDataLoaded },
              },
              "component",
              _vm.dataSourceAdapterOptions.props,
              false
            )
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }